import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

import PageTitle from '../components/ui/PageTitle';
import PostEditor from '../components/ui/PostEditor';

export default function NewPost({ isMobile }) {
	useEffect(() => {
		window.gtag('config', 'G-HGSNKWLS5N', {'page_title': 'New Post', 'page_location': window.location.href, 'page_path': '/newpost'});
	}, []);

	return (
		<motion.div initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.8 }}>
			<PageTitle>New Post</PageTitle>
			<PostEditor providedDate={new Date()} isMobile={isMobile} />
		</motion.div>
	)
}